export default "__VITE_ASSET__D21Bu2nV__"